export default __webpack_public_path__ + "static/media/Config.edee6240.svg";